module.exports = __webpack_public_path__ + "static/media/logo-type.f0247375.png";